import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ProductList from '@/components/ProductList.vue';
import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

onMounted(() => {
  document.title = "Unifix Care - Products";
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ProductList))
}
}

})